import React from 'react'
import DashBoard from '../modules/DashBoard/DashBoard'

const Index: React.FC = () => {
  return <DashBoard />
}

export default Index
